import React, { useEffect, useState } from "react";
import "./navBar.scss";

import { Link, useLocation } from "react-router-dom";

import Logo from "../../assets/Images/Alpaca_Logo_Black_Horizontal.svg";

export function NavBar(props) {
  const [isSticky, setIsSticky] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 200);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isGetDemoPage = location.pathname.includes("get-a-demo");

  return (
    <nav>
      {/* <div className="navTopSection">
        <div className="alpacaDetails">
          <ul>
            <li className="alpacaLink">All Alpaca Solutions</li>
            <div className="verticalDivider"></div>
            <li className="alpacaLink">About Alpaca</li>
          </ul>
        </div>
      </div> */}
      <div
        className={
          isSticky
            ? "navBottomSectionSticky navBottomSection"
            : "navBottomSection"
        }
      >
        <div className="navLogoContainer">
          <Link to="/">
            <img src={Logo} className="navLogo" alt="logo" />
          </Link>
        </div>

        {!isGetDemoPage && (
          <div className="navActionBtnContainer">
            <Link to="/get-a-demo">
              <button className="textBtn getDemoBtn">Get a Demo</button>
            </Link>
            <Link to="/get-a-demo">
              <button className="roundBtn">
                Get Started for <span className="btnEmphasis">FREE</span>
              </button>
            </Link>
          </div>
        )}
      </div>

      {!isGetDemoPage && (
        <div className="getDemoMobileBtn">
          <Link to="/get-a-demo">
            <button className="roundBtn">
              Get Started for <span className="btnEmphasis">FREE</span>
            </button>
          </Link>
        </div>
      )}
    </nav>
  );
}
